import type { TImageProps } from "@/ui/components/primitives";
import type { DefinedDefaults, TWithDataComponent } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const SOCIAL_PROOF_CARD_ARTICLE_CLASS = "w-[280px] shrink-0 overflow-hidden rounded-sys-lg border border-outline-dark bg-sys-white shadow-md";

export const SOCIAL_PROOF_CARD_AVATAR_FALLBACK_CLASS = "h-6 w-6 shrink-0 rounded-full bg-component-social-proof-avatar font-bold text-foreground-inverse";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TSocialProofCardAuthor = {
  name: string;
  avatar?: TImageProps;
};

export type TSocialProofCardProps = TWithDataComponent & {
  author: TSocialProofCardAuthor;
  body: string;
  image: TImageProps;
};

type TSocialProofCardDefaultProps = DefinedDefaults<
  TSocialProofCardProps,
  "data-component"
>;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const SOCIAL_PROOF_CARD_DEFAULTS = {
  "data-component": "SocialProofCard",
} satisfies TSocialProofCardDefaultProps;
